<template>
  <div
    :contenteditable="textSize"
    id="message"
    class="textarea border-2 border-gray-200 rounded-md"
    data-text=""
    @keyup.enter.prevent="onGetMessage"
  ></div>
  <button
    v-if="!recorded"
    @click="onStartRecord"
    class="btn-simple w-10"
    title="aperte o botão para gravar um áudio"
  >
    <v-icon name="hi-solid-microphone" class="text-primary-400" />
  </button>
  <button
    v-if="recorded"
    @click="onRecordStop"
    class="btn-simple w-10"
    title="aperte o botão para parar gravação"
  >
    <v-icon
      name="md-stopcircle-outlined"
      class="text-h-error-400 animate-pulse"
      :scale="1.5"
    />
  </button>
  <button class="btn-simple w-10" @click.prevent="onGetMessage">
    <v-icon name="md-send-sharp" class="text-primary-400" />
  </button>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "chatFooter",
  emits: ["onRecordStop", "onStartRecord", "onGetMessage"],
  props: {
    textSize: {
      type: Boolean,
    },
    recorded: {
      type: Boolean,
    },
  },
  methods: {
    onRecordStop(): void {
      this.$emit("onRecordStop");
    },
    onStartRecord(): void {
      this.$emit("onStartRecord");
    },
    onGetMessage(): void {
      this.$emit("onGetMessage");
    },
  },
});
</script>

<style lang="scss" src="./style.scss"></style>
